import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { toastr } from "react-redux-toastr";
import { useCurrentUser } from "APP_ROOT/hooks";
import {
  FilterSelect,
  Pagination,
  SearchFilter,
  TitleWithFilters
} from "MODULES/shared/components/Pagination";
import { renderIf } from "MODULES/shared/decorators";
import { Search, Button } from "MODULES/shared/components";
import { ADMIN, EXPORT_LIMIT } from "MODULES/users/constants";
import { API_BASE } from "APP_ROOT/constants";
import { SUCCESS } from "LIB/submission";
import { stringify } from "query-string";
import { matchesBoolean } from "LIB/filters";
import api from "APP_ROOT/api";
import Table from "./Table";
import pagination from "../pagination";

const filters = [
  {
    label: "Only Mine",
    filters: { current_user: true }
  },
  {
    label: "All",
    filters: { current_user: undefined }
  },
  {
    label: "Open Warranty Requests",
    filters: { open_warranty_consideration: true }
  },
  {
    label: "Closed Warranty Requests",
    filters: { open_warranty_consideration: false }
  },
  {
    label: "Cancelled RMAs",
    filters: { cancelled: true }
  },
  {
    label: "Open Credit Requests",
    filters: {
      open_credit_requests: true
    }
  },
  {
    label: "Closed Credit Requests",
    filters: { credit_requested: true, credit_issued: true }
  },
  {
    label: "No Warranty Requested",
    filters: { warranty_consideration: false }
  },
  {
    label: "No Credit Requested",
    filters: { credit_requested: false }
  },
  {
    label: "Cust Warr unit not received",
    filters: { date_in_blank: true }
  },
  {
    label: "Cust Warr unit received",
    filters: { date_in_blank: false }
  },
  {
    label: "Received",
    filters: { received: true }
  },
  {
    label: "Not Received",
    filters: { received: false }
  },
  {
    label: "No Incoming AWB",
    filters: { incoming_awb_number: false }
  }
];

const filterTags = [
  {
    label: "Only Mine",
    key: "current_user"
  },
  {
    label: "Cancelled",
    key: "cancelled",
    matchesTarget: matchesBoolean(true)
  },
  {
    label: "Open Warranty Requests",
    key: "open_warranty_consideration",
    matchesTarget: matchesBoolean(true)
  },
  {
    label: "Closed Warranty Requests",
    key: "open_warranty_consideration",
    matchesTarget: matchesBoolean(false)
  },
  {
    label: "Open Credit Requests",
    key: "open_credit_requests"
  },
  {
    label: "Closed Credit Requests",
    key: "credit_issued",
    matchesTarget: matchesBoolean(true)
  },
  {
    label: "WC",
    key: "warranty_consideration",
    matchesTarget: matchesBoolean(true)
  },
  {
    label: "No Warranty Requested",
    key: "warranty_consideration",
    matchesTarget: matchesBoolean(false)
  },
  {
    label: "No Credit Requested",
    key: "credit_requested",
    matchesTarget: matchesBoolean(false)
  },
  {
    label: "Warr unit not received",
    key: "date_in_blank",
    matchesTarget: matchesBoolean(true)
  },
  {
    label: "Warr unit received",
    key: "date_in_blank",
    matchesTarget: matchesBoolean(false)
  },
  {
    label: "Received",
    key: "received",
    matchesTarget: matchesBoolean(true)
  },
  {
    label: "Not Received",
    key: "received",
    matchesTarget: matchesBoolean(false)
  },
  {
    label: "No Incoming AWB",
    key: "incoming_awb_number",
    matchesTarget: matchesBoolean(false)
  }
];

const ExportButton = ({ searchProps }) => {
  const params = searchProps.paginator.get("filters").toJS();
  const totalCount = searchProps.paginator.get("totalCount");

  params.total_count = totalCount;
  return (
    <Button
      onClick={() => {
        if (totalCount > EXPORT_LIMIT) {
          toastr.info("Processing");
          api.customerRmas.export(params).then(() => SUCCESS);
        } else {
          window.open(
            `${API_BASE}/customer_rmas/export?${stringify(params)}`,
            "_blank"
          );
          toastr.success(
            "Processing Customer RMA Report. Please wait for the PDF to generate."
          );
        }
      }}
    >
      Export
    </Button>
  );
};

const meetsExportCriteria = renderIf(
  ({ searchProps, currentUser }) =>
    searchProps.paginator.get("totalCount") <= 450 || currentUser.role === ADMIN
);

const DecoratedExportButton = meetsExportCriteria(ExportButton);

function RmasSearch({ pushHistory }) {
  return (
    <Search search={pagination} syncWithUrl>
      {searchProps => (
        <div>
          <div className="form-group form-group-searchbar has-feedback has-feedback-left">
            <i className="text-muted fa fa-search form-control-feedback form-control-feedback-left" />
            <div className="input-group">
              <SearchFilter
                {...searchProps}
                placeholder="Search by typing Company Name, RMA Number, Serial Number or Part Number..."
                submitOnSingleResult={r => pushHistory(`/rmas/${r.id}`)}
              />
              <DecoratedExportButton
                searchProps={searchProps}
                currentUser={useCurrentUser()}
              />
              <FilterSelect {...searchProps} filters={filters} right />
            </div>
          </div>
          <TitleWithFilters
            {...searchProps}
            title="Customer RMA"
            filters={filterTags}
            aggregateField={rma =>
              rma.sales_item.exchange_sale
                ? parseFloat(rma.sales_item.exchange_fee)
                : parseFloat(rma.sales_item.price_per_unit) *
                  parseFloat(rma.sales_item.quantity)}
          />
          <Table {...searchProps} />
          <Pagination {...searchProps} />
        </div>
      )}
    </Search>
  );
}

RmasSearch.propTypes = {
  pushHistory: PropTypes.func.isRequired
};

export default connect(undefined, { pushHistory: push })(RmasSearch);



// WEBPACK FOOTER //
// ./app/modules/CustomerRmas/components/Search.jsx